import { render, staticRenderFns } from "./TreeFoldersComponent.vue?vue&type=template&id=a0b540d4&scoped=true&"
import script from "./TreeFoldersComponent.vue?vue&type=script&lang=js&"
export * from "./TreeFoldersComponent.vue?vue&type=script&lang=js&"
import style0 from "./TreeFoldersComponent.vue?vue&type=style&index=0&id=a0b540d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b540d4",
  null
  
)

export default component.exports